<template>
  <section class="container flex justify-center -mt-16 mb-40 md:mb-32 sm:mt-0 md:-mt-16">
    <div class="card test bg-white h-full w-full sm:w-10/12 md:w-6/12 xl:w-5/12 xxl:w-4/12 py-8 px-6 sm:p-16">
      <div class="leading-loose" v-html="htmlString"/>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    htmlString: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="sass" scoped>
.container
  position: relative
  &::before
    position: absolute
    content: ''
    top: -12%
    bottom: 65%
    left: -4%
    right: 0
    background: url("~assets/img/match/oranje-bubble.svg") no-repeat
    background-size: contain
    @media(min-width: theme('screens.sm'))
      bottom: 40%
    @media(min-width: theme('screens.md'))
      left: 22%

  &::after
    position: absolute
    content: ''
    top: 80%
    bottom: -22%
    left: 56%
    right: 0
    background: url("~assets/img/match/blauwe-bubble.svg") no-repeat
    background-size: contain
    @media(min-width: theme('screens.sm'))
      top: 56%
    @media(min-width: theme('screens.md'))
      top: 42%
</style>
